import { c as _c } from "react/compiler-runtime";
import Typography from '@precis-digital/kurama/Typography';
import { renderInlineMarkdown } from 'shared/markdown/renderInlineMarkdown';
import { type ReactElement } from 'react';
interface MarkdownTableInlineCellProps {
  value: string;
  variant?: 'body2' | 'body3';
  markdownVariant?: 'compact' | 'standard';
  fontWeight?: number;
}

/**
 * Renders a markdown table cell/header value with bold/italic/code applied.
 */
export const MarkdownTableInlineCell = t0 => {
  const $ = _c(9);
  const {
    value,
    variant: t1,
    markdownVariant: t2,
    fontWeight
  } = t0;
  const variant = t1 === undefined ? "body2" : t1;
  const markdownVariant = t2 === undefined ? "compact" : t2;
  let t3;
  if ($[0] !== fontWeight) {
    t3 = fontWeight == null ? undefined : {
      fontWeight
    };
    $[0] = fontWeight;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== markdownVariant || $[3] !== value) {
    t4 = renderInlineMarkdown(value, {
      variant: markdownVariant
    });
    $[2] = markdownVariant;
    $[3] = value;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t3 || $[6] !== t4 || $[7] !== variant) {
    t5 = <Typography variant={variant} style={t3}>{t4}</Typography>;
    $[5] = t3;
    $[6] = t4;
    $[7] = variant;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
};